module.exports = __webpack_public_path__ + "img/prediction_view.d42a6e8c.png";